import { useTranslate } from '@tolgee/react';
import { GetStaticProps } from 'next';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { getNavigation, getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';
import ContactSend from '@amf/shared/components/contact/ContactSend';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

interface ContactPageProps extends NavigationProps {}

export default function ContactPage({ navigation, partners }: ContactPageProps) {
  const { t } = useTranslate();
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'head',
      }}
    >
      <div className='ContactPage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('contact.title')} />
          <Container>
            <h1>{t('contact.title')}</h1>
            <div className='ContactPage__content'>
              <ContactSend />
              <div className='ContactPage__info'>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.info.title')}</h2>
                  <address>
                    Asociace malého fotbalu
                    <br />
                    Peroutkova 570/83, 158 00 Praha 5
                  </address>
                  <p>
                    <a href='mailto:info@malyfotbal.cz'>info@malyfotbal.cz</a>
                    <br />
                    <a href='tel:++420602725382'>+420 602 725 382</a>
                  </p>
                  <br />
                  <address>
                    <strong>Kancelář AMF ČR</strong>
                    <br />
                    Peroutkova 570/83
                    <br />
                    158 00 Praha 5
                  </address>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.billing.title')}</h2>
                  <address>
                    <strong>Asociace malého fotbalu ČR, z.s.</strong>
                    <br />
                    Roháčova 145/14
                    <br />
                    130 00 Praha 3
                  </address>
                  <p>IČ: 26995751</p>
                  <p>{t('contact.billing.account')}: 2802392332/2010</p>
                </div>
                <div className='ContactPage__infoPanel'>
                  <h2>{t('contact.social.title')}</h2>
                  <p>
                    <a href='https://www.facebook.com/malyfotbal1' target='_blank' rel='noreferrer'>
                      Facebook
                    </a>
                    <br />
                    <a
                      href='https://www.instagram.com/malyfotbal/'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Instagram
                    </a>
                    <br />
                    <a
                      href='https://www.youtube.com/channel/UC1A-Fqc9Z1uVQL5HEyNMTdg'
                      target='_blank'
                      rel='noreferrer'
                    >
                      Youtube
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <h2 className='h1'>{t('contact.persons.title')}</h2>
            <div className='ContactPage__personList'>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto ContactPage__personPhoto--renePazdera' />
                <div className='ContactPage__personInfo'>
                  <h3>René Pazdera</h3>
                  <p>
                    Generální sekretář
                    <br />
                    <br />
                    <a href='tel:+420602725382'>+420 602 725 382</a>
                    <br />
                    <a href='mailto:info@malyfotbal.cz'>info@malyfotbal.cz</a>
                  </p>
                </div>
              </div>
              <div className='ContactPage__person'>
                <div className='ContactPage__personPhoto ContactPage__personPhoto--jaroslavKara' />
                <div className='ContactPage__personInfo'>
                  <h3>Jaroslav Kára</h3>
                  <p>
                    Tiskový mluvčí
                    <br />
                    <br />
                    <a href='mailto:jaroslav.kara@malyfotbal.cz'>jaroslav.kara@malyfotbal.cz</a>
                  </p>
                </div>
              </div>
            </div>
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      navigation: await getNavigation(getLanguageLocale(locale!)),
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
